import makeEnum from 'services/store/utils/actions/makeEnum';

export const types = makeEnum(
  'LOGIN',
  'LOGOUT',
  'SET_DATA',                                // Generic action to set data, used by realtime updates
  'SET_STATUS',
  'CLEAR_ALL_STATUSES',
);
